export type ScrapAlertKind = 'employee' | 'part' | 'scrap_type' | 'component';
export type ScrapAlertStatus = 'open' | 'acknowledged' | 'cleared';

export interface ScrapLogSummaryEmployee {
  user_id: string;
  scrap_units: number;
  cents: number;
}

export interface ScrapLogSummaryPart {
  item_id: string;
  scrap_units: number;
  cents: number;
}

export interface ScrapLogSummaryTag {
  tag: string;
  count: number;
}

export interface ScrapLogSummaryComponent {
  key: string;
  name: string;
  sku: string | null;
  qty: number;
  events: number;
  cents: number;
}

/** Return shape of `scrap_log_summary`. Window is the trailing N days. */
export interface ScrapLogSummary {
  window_days: number;
  good_units: number;
  scrap_units: number;
  scrap_rate: number | null;
  material_cents: number;
  labor_cents: number;
  total_cents: number;
  committed_seconds: number;
  rework_count: number;
  scrap_logs: number;
  labor_missing: number;
  uncosted_component_lines: number;
  top_employee: ScrapLogSummaryEmployee | null;
  top_part: ScrapLogSummaryPart | null;
  top_tag: ScrapLogSummaryTag | null;
  top_component: ScrapLogSummaryComponent | null;
}

export interface ScrapAlert {
  id: string;
  organization_id: string;
  kind: ScrapAlertKind;
  subject_key: string;
  title: string;
  detail: string;
  recommendation: string;
  scrap_count: number;
  sample_count: number;
  scrap_rate: number;
  baseline_rate: number;
  z_score: number;
  dollar_cents: number;
  window_days: number;
  status: ScrapAlertStatus;
  first_seen_at: string;
  last_seen_at: string;
  acknowledged_by: string | null;
  acknowledged_at: string | null;
}

export const SCRAP_ALERT_KIND_LABEL: Record<ScrapAlertKind, string> = {
  employee: 'Person',
  part: 'Part',
  scrap_type: 'Scrap type',
  component: 'Component',
};
